/*
 * ux-boost.js (Elusive, 6 oktober 2026). Geen library.
 * 1. Levertijd met aftelling: [data-ux-delivery] krijgt een live tekst op basis van Nederlandse tijd.
 *    Regels (verzendbeleid Sophitech): op werkdagen voor de deadline besteld = vandaag verzonden.
 *    Nederland: de werkdag na verzending in huis (zoals de verzendmethode in de checkout belooft).
 *    Valt die bezorgdag na een weekend of vrije dag, dan staat er "uiterlijk", want zaterdagbezorging is niet gegarandeerd.
 *    België: 1 tot 2 werkdagen (verzendzone België).
 * 2. Bundelkeuze (Essential Upsell): klik ergens op een kaart = het vinkje van die kaart omzetten.
 *    Werkt via structuur (kaart = kleinste voorouder met precies één vinkje), niet via de gegenereerde classnamen van de app.
 */
(function () {
  'use strict';

  /* ---------- 1. Levertijd ---------- */
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

  function amsterdamNow() {
    // Tijd in Europe/Amsterdam als losse velden, onafhankelijk van de tijdzone van het toestel.
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var h = +parts.hour === 24 ? 0 : +parts.hour;
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: h, min: +parts.minute, s: +parts.second };
  }
  function ymd(date) { // date = Date in UTC-middag van die kalenderdag
    var m = date.getUTCMonth() + 1, d = date.getUTCDate();
    return date.getUTCFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
  }
  function addDays(date, n) { var x = new Date(date.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function isWorkday(date, closed) { var wd = date.getUTCDay(); return wd !== 0 && wd !== 6 && closed.indexOf(ymd(date)) === -1; }
  function nextWorkday(date, closed) { var x = addDays(date, 1); while (!isWorkday(x, closed)) x = addDays(x, 1); return x; }
  function label(date, today) {
    var diff = Math.round((date - today) / 86400000);
    var base = DAYS[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + MONTHS[date.getUTCMonth()];
    if (diff === 0) return 'vandaag';
    if (diff === 1) return 'morgen (' + base + ')';
    return base;
  }

  function renderDelivery(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 20;
    var closed = (el.getAttribute('data-closed') || '').split(',').filter(Boolean);
    var now = amsterdamNow();
    var today = new Date(Date.UTC(now.y, now.m - 1, now.d, 12));
    var shipToday = isWorkday(today, closed) && now.h < cutoff;
    var ship = shipToday ? today : nextWorkday(today, closed);
    var deliver = nextWorkday(ship, closed);
    var gap = Math.round((deliver - ship) / 86400000) > 1; // weekend of vrije dag ertussen
    var first;
    if (shipToday) {
      var left = (cutoff * 60) - (now.h * 60 + now.min);
      var hh = Math.floor(left / 60), mm = left % 60;
      var t = hh > 0 ? hh + ' u ' + mm + ' min' : mm + ' min';
      first = 'Bestel binnen <b>' + t + '</b>, dan verzenden we vandaag.';
    } else {
      first = 'Nu besteld, <b>' + label(ship, today) + '</b> verzonden.';
    }
    var second = 'Nederland: ' + (gap ? 'uiterlijk ' : '') + label(deliver, today) + ' in huis · België: 1 tot 2 werkdagen';
    el.innerHTML = '<span class="ux-delivery__main">' + first + '</span><span class="ux-delivery__sub">' + second + '</span>';
    el.classList.add('is-live');
    var host = el.closest('.sm-info');
    if (host) host.classList.add('ux-delivery-on');
  }
  function tick() { document.querySelectorAll('[data-ux-delivery]').forEach(renderDelivery); }
  if (window.Intl && Intl.DateTimeFormat && Intl.DateTimeFormat.prototype.formatToParts) {
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- 2. Bundelkeuze: hele kaart aanklikbaar ---------- */
  if (document.documentElement.hasAttribute('data-ux-fbt')) {
    document.addEventListener('click', function (e) {
      var block = e.target.closest && e.target.closest('[id*="essential_upsell_frequently_bought_together"]');
      if (!block) return;
      if (e.target.closest('input, button, a, label, select')) return;
      var node = e.target;
      while (node && node !== block) {
        var boxes = node.querySelectorAll ? node.querySelectorAll('input[type="checkbox"]') : [];
        if (boxes.length === 1) {
          if (!boxes[0].disabled) boxes[0].click();
          return;
        }
        if (boxes.length > 1) return; // te hoog: meerdere kaarten
        node = node.parentElement;
      }
    });
  }
})();
